import { DeleteClientTransactionComponent } from './delete-client-transaction/delete.client.transaction.component';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MdDialog } from '@angular/material';
import { Router } from '@angular/router';

import { environment } from 'environments/environment';

import { ConstantsService } from 'app/services/constants-service';
import { CookieService } from 'app/services/cookie.service';
import { MessageService } from 'app/services/messages.service';

import { TimesheetComponent } from './timesheethandler/timesheet.component';
import { UploadMt940FileComponent } from './uploadmt940file/upload-mt940-file.component';

import { Task } from 'app/shared/models/task.model';

import { AuthenticationGuard } from 'app/services/authentication-guard.service';
import { NavigationBarService } from './navigation-bar.service';

@Component({
    selector: 'app-navigation-bar',
    templateUrl: './navigation-bar.component.html',
    styleUrls: ['./navigation-bar.component.css']
})

/**
 * Component for displaying a parallel navigation bar.
 */
export class NavigationBarComponent implements OnInit {
    active: String = 'active';
    inactive: String = 'inactive';

    popoutTaskVisible: boolean;
    popoutTask: Task;

    // Almost deprecated
    tenantConfigurationRoute = ConstantsService.TENANT_CONFIGURATION_COMPONENT_ROUTE;
    groupURL = ConstantsService.GROUP_IFRAME_SUFFIX;
    sanctionLogsURL = ConstantsService.SANC_LOGS_IFRAME_SUFFIX;
    surveryConfigURL = ConstantsService.SURVEY_CONFIG_IFRAME_SUFFIX;
    tenantConfigURL = ConstantsService.TENANT_CONFIG_IFRAME_SUFFIX;
    surveyTemplateURL = ConstantsService.SURVEYTEMPLATE_IFRAME_SUFFIX;
    appActivitiesURL = ConstantsService.APP_ACTIVITY_IFRAME_SUFFIX;
    configRulesURL = ConstantsService.CONFIG_RULES_IFRAME_SUFFIX;
    configRulesGrpMappingURL = ConstantsService.CONFIG_RULE_GRP_MAPPING_IFRAME_SUFFIX;
    ruleAppParamsURL = ConstantsService.RULE_APP_PARAMS_IFRAME_SUFFIX;
    listProcessesURL = ConstantsService.LIST_PROCESSES_IFRAME_SUFFIX;
    importClientDataURL = ConstantsService.IMPORT_CLIENT_DATA_IFRAME_SUFFIX;
    servicesURL = ConstantsService.SERVICES_IFRAME_SUFFIX;
    exactOnlineLoginURL = ConstantsService.EXACT_ONLINE_POP_UP_URL;
    importsUrl = ConstantsService.IMPORTS_IFRAME_SUFIX;
    transactionProfilesExportRoute = ConstantsService.TRANSACTION_PROFILE_EXPORT_COMPONENT_ROUTE;

    // Component Routes
    dnbDashboardRoute = ConstantsService.DNB_DASHBOARD_COMPONENT_ROUTE;
    dashboardRoute = ConstantsService.DASHBOARD_COMPONENT_ROUTE;
    clientsOverviewRoute = ConstantsService.CLIENTS_OVERVIEW_COMPONENT_ROUTE;
    clientReviewRoute = ConstantsService.CLIENT_REVIEW_COMPONENT_ROUTE;
    sanctionLogsRoute = ConstantsService.SANCTION_LOGS_COMPONENT_ROUTE;
    mainISIReport2017 = ConstantsService.MAIN_ISI_COMPONENT_ROUTE + '/headOffice/2017';
    mainISIReport2018 = ConstantsService.MAIN_ISI_COMPONENT_ROUTE + '/headOffice/2018';
    mainISIReport2019 = ConstantsService.MAIN_SECOND_ISI_COMPONENT_ROUTE + '/2019';
    mainISIReport2020 = ConstantsService.MAIN_SECOND_ISI_COMPONENT_ROUTE + '/2020';
    mainISIReport2021 = ConstantsService.MAIN_SECOND_ISI_COMPONENT_ROUTE + '/2021';
    mainISIReport2022 = ConstantsService.MAIN_SECOND_ISI_COMPONENT_ROUTE + '/2022';
    mainISIReport2023 = ConstantsService.MAIN_SECOND_ISI_COMPONENT_ROUTE + '/2023';
    mainISIReport2024 = ConstantsService.MAIN_SECOND_ISI_COMPONENT_ROUTE + '/2024';
    mainISIReport2025 = ConstantsService.MAIN_SECOND_ISI_COMPONENT_ROUTE + '/2025';
    bankStatementBatchRoute = ConstantsService.BANK_STATEMENT_BATCH_COMPONENT_ROUTE;
    pendingTransactionsOverviewRoute = ConstantsService.PENDING_TRANSACTIONS_OVERVIEW_COMPONENT_ROUTE;
    pendingHitsOverviewRoute = ConstantsService.PENDING_HITS_OVERVIEW_COMPONENT_ROUTE;
    paymentsRoute = ConstantsService.PAYMENTS_COMPONENT_ROUTE;
    workflowRoute = ConstantsService.WORKFLOW_COMPONENT_ROUTE;
    usersRoute = ConstantsService.ADMIN_USERS_COMPONENT_ROUTE;
    groupRoute = ConstantsService.ADMIN_GROUP_COMPONENT_ROUTE;

    archivalRoute = ConstantsService.ARCHIVAL_MANAGEMENT_COMPONENT_ROUTE;
    bankInstitutionsRoute = ConstantsService.BANK_INSTITUTION_MANAGEMENT_COMPONENT_ROUTE;
    integrationsRoute = ConstantsService.INTEGRATION_MANAGEMENT_COMPONENT_ROUTE;
    processRoute = ConstantsService.PROCESS_TASK_MANAGEMENT_COMPONENT_ROUTE;
    rulesRoute = ConstantsService.ADMIN_RULES_COMPONENT_ROUTE;
    surveysRoute = ConstantsService.SURVEY_MANAGEMENT_COMPONENT_ROUTE;
    adminServiceRoute = ConstantsService.ADMIN_SERVICES_COMPONENT_ROUTE;
    appActivityRoute = ConstantsService.APPLICATION_ACTIVITY_COMPONENT_ROUTE;
    importClientRoute = ConstantsService.IMPORT_CLIENT_COMPONENT_ROUTE;

    // @todo clean-up collection of flags
    showDashboard = environment.showDashboard;
    showUserMenu = environment.showUserMenu;
    showGroupMenu = environment.showGroupMenu;
    showArchivalMenu = environment.showArchivalMenu;
    showPaymentMenu = environment.showPaymentMenu;
    showSurveyMenu = environment.showSurveyMenu;
    showProcessesMenu = environment.showProcessesMenu;

    showIntegrationsMenu = environment.showIntegrationManagement;
    showApplicationActivityMenu = environment.showApplicationActivity;
    showImportClientMenu = environment.showImportClient;

    // Sub menu mappings.
    subMenuList: Menu[] = [
        {
            name: 'dashboard', componentRoute: this.dashboardRoute,
            parentMenuName: MenuNameConstants.DASHBOARD
        },
        {
            name: 'clients', componentRoute: this.clientReviewRoute,
            parentMenuName: MenuNameConstants.CLIENTS
        },
        {
            name: 'clients', componentRoute: this.clientsOverviewRoute,
            parentMenuName: MenuNameConstants.CLIENTS
        },
        {
            name: 'reports', componentRoute: this.sanctionLogsRoute,
            parentMenuName: MenuNameConstants.REPORTS
        },
        {
            name: 'reports', componentRoute: this.mainISIReport2017,
            parentMenuName: MenuNameConstants.REPORTS
        },
        {
            name: 'reports', componentRoute: this.mainISIReport2018,
            parentMenuName: MenuNameConstants.REPORTS
        },

        {
            name: 'bankStatementBatch', componentRoute: this.bankStatementBatchRoute,
            parentMenuName: MenuNameConstants.PAYMENTS
        },
        {
            name: 'pendingTransactionsOverview', componentRoute: this.pendingTransactionsOverviewRoute,
            parentMenuName: MenuNameConstants.PAYMENTS
        },
        {
            name: 'pendingHitsOverview', componentRoute: this.pendingHitsOverviewRoute,
            parentMenuName: MenuNameConstants.REPORTS
        },
        {
            name: 'payments', componentRoute: this.paymentsRoute,
            parentMenuName: MenuNameConstants.PAYMENTS
        },
        {
          name: 'workflow',
          componentRoute: this.workflowRoute,
          parentMenuName: MenuNameConstants.WORKFLOW,
        },
        {
            name: 'users', componentRoute: this.usersRoute,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: 'groups', componentRoute: this.groupRoute,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: 'surveys', componentRoute: this.surveysRoute,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: 'applicationActivity', componentRoute: this.appActivityRoute,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: 'importClient', componentRoute: this.importClientRoute,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: 'bankinstitutions', componentRoute: this.bankInstitutionsRoute,
            parentMenuName: MenuNameConstants.ADMIN
            // @todo temp location >> Finance tab
        },
        {
            name: 'integrations', componentRoute: this.integrationsRoute,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: 'archivals', componentRoute: this.archivalRoute,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: 'processes', componentRoute: this.processRoute,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: 'rules', componentRoute: this.rulesRoute,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: 'services', componentRoute: this.adminServiceRoute,
            parentMenuName: MenuNameConstants.ADMIN
        },
        // Old stuff
        {
            name: this.sanctionLogsURL, componentRoute: this.sanctionLogsURL,
            parentMenuName: MenuNameConstants.REPORTS
        },
        {
            name: this.surveryConfigURL, componentRoute: this.surveryConfigURL,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: this.tenantConfigURL, componentRoute: this.tenantConfigURL,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: this.surveyTemplateURL, componentRoute: this.surveyTemplateURL,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: this.appActivitiesURL, componentRoute: this.appActivitiesURL,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: this.configRulesURL, componentRoute: this.configRulesURL,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: this.configRulesGrpMappingURL, componentRoute: this.configRulesGrpMappingURL,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: this.ruleAppParamsURL, componentRoute: this.ruleAppParamsURL,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: this.listProcessesURL, componentRoute: this.listProcessesURL,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: this.importClientDataURL, componentRoute: this.importClientDataURL,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: this.servicesURL, componentRoute: this.servicesURL,
            parentMenuName: MenuNameConstants.ADMIN
        },
        {
            name: this.exactOnlineLoginURL, componentRoute: this.exactOnlineLoginURL,
            parentMenuName: MenuNameConstants.ADMIN
        },
    ];

    mainMenus: Menu[] = [
        { name: 'dashBoard', activeClass: this.active },
        { name: 'clients', activeClass: this.inactive },
        { name: 'reports', activeClass: this.inactive },
        { name: 'payments', activeClass: this.inactive },
        { name: 'timeSheet', activeClass: this.inactive },
        { name: 'admin', activeClass: this.inactive },
        { name: 'workflow', activeClass: this.inactive },
    ];

    homeIFrameUrl: any;

    constructor(
        private router: Router,
        private authenticationGuard: AuthenticationGuard,
        private cookieService: CookieService,
        private dialog: MdDialog,
        private domSanitizer: DomSanitizer,
        private navigationService: NavigationBarService
    ) {

        // Need this url for GWT one-time SSO
        const loggedinSessionId = this.cookieService.get(ConstantsService.COOKIE_SESSION_ID);
        const homePageUrl = ConstantsService.HOME_PAGE_IFRAME_URL + loggedinSessionId;

        this.homeIFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(homePageUrl);

        // Subscription for task popout selection
        this.navigationService.onSelectedTaskChanged().subscribe(
            task => {
                if (this.popoutTaskVisible) {
                    if (!confirm(MessageService.TASK_CHANGE_ALERT)) {
                        return;
                    }
                }

                this.popoutTask = task;
                this.popoutTaskVisible = true;
            }
        );
    }

    getHeaderTitle() {
        if (this.popoutTask == null) {
            return '';
        }
        return 'Task for: ' + this.popoutTask.entityName;
    }

    canReport() {
      const isCompliance: boolean = this.cookieService.get(ConstantsService.COOKIE_COMPLIANCE_OFFICER) === 'true';
      return this.isAdminUser() || isCompliance;
    }

    notDNB() {
      return !this.isDNBUser();
    }

    isDNBUser() {
      return this.authenticationGuard.isDnbUser();
    }

    isAdminUser() {
        return this.authenticationGuard.isAdminUser();
    }

    ngOnInit() {
        // @todo temp fix for handling hard refresh
        if ((document.URL).indexOf('entity') !== -1) {
            this.updateActiveMenu('/clients');
            this.updateActiveMenu('/reports');
        } else {
            for (var i in this.mainMenus) {
                var menu: String = this.mainMenus[i].name;
                if (document.URL.indexOf('' + menu) != -1) {
                    this.updateActiveMenu('/' + menu);
                    break;
                }
            }
        }
    }

    routeToComponent(componentRoute) {
        this.router.navigateByUrl(componentRoute);
        this.updateActiveMenu(componentRoute);
    }

    openIframe(urlSuffix: string) {
        this.router.navigate(['/appContent'], { queryParams: { iframeUrl: urlSuffix, random: Math.random() } });
        this.updateActiveMenu(urlSuffix);
    }

    openTimeKeepingDialog() {
        this.dialog.open(TimesheetComponent);
    }

    openUploadMt940FileDialog() {
        this.dialog.open(UploadMt940FileComponent);
    }

    openDeleteClientDialog() {
        this.dialog.open(DeleteClientTransactionComponent);
    }

    validateData() {
        this.navigationService.validDateData().subscribe(
            response => {
                if (response.arrResult.length != 0) {
                    let allTestTrue = true;
                    let failedTest = '';
                    response.arrResult.forEach(element => {
                        if (!element.verificationResult) {
                            failedTest += element.verificationTitle + ': Failed' + '\n';
                            allTestTrue = false;
                        }
                    });
                    if (allTestTrue) {
                        alert('All Test Passed');
                    } else {
                        alert(failedTest);
                    }
                }
            });
    }

    downloadISIReport2017() {
        window.open(ConstantsService.APP_BE_URL + ConstantsService.PRINT_REPORT_SERVLET + ConstantsService.PARAM_ISI_2017);
    }

    downloadISIReport2018() {
        window.open(ConstantsService.APP_BE_URL + ConstantsService.PRINT_REPORT_SERVLET + ConstantsService.PARAM_ISI_2018);
    }

    downloadISIReport2019() {
        window.open(ConstantsService.APP_BE_URL + ConstantsService.PRINT_REPORT_SERVLET + ConstantsService.PARAM_ISI_2019);
    }

    downloadISIReport2020() {
        window.open(ConstantsService.APP_BE_URL + ConstantsService.PRINT_REPORT_SERVLET + ConstantsService.PARAM_ISI_2020);
    }

    downloadISIReport2021() {
      window.open(ConstantsService.APP_BE_URL + ConstantsService.PRINT_REPORT_SERVLET + ConstantsService.PARAM_ISI_2021);
    }

    downloadISIReport2022() {
      window.open(ConstantsService.APP_BE_URL + ConstantsService.PRINT_REPORT_SERVLET + ConstantsService.PARAM_ISI_2022);
    }

    downloadISIReport2023() {
      window.open(ConstantsService.APP_BE_URL + ConstantsService.PRINT_REPORT_SERVLET + ConstantsService.PARAM_ISI_2023);
    }

    downloadISIReport2024() {
      window.open(ConstantsService.APP_BE_URL + ConstantsService.PRINT_REPORT_SERVLET + ConstantsService.PARAM_ISI_2024);
    }

    downloadISIReport2025() {
      window.open(ConstantsService.APP_BE_URL + ConstantsService.PRINT_REPORT_SERVLET + ConstantsService.PARAM_ISI_2025);
    }

    openExactOnlineLogin(exactOnlineLoginURL: string) {
        window.open(exactOnlineLoginURL, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    }

    /**
     * This function can be used in future if navigation is being done through routs.
     * We will require to create a class by extending CanActivate. This class will send event to navigation
     * component to update the menu.
     */
    updateActiveMenu(componentRoute: String) {
        this.subMenuList.forEach(subMenu => {
            if (subMenu.componentRoute === componentRoute) {
                this.mainMenus.forEach(mainMenu => {
                    mainMenu.activeClass = subMenu.parentMenuName === mainMenu.name ? this.active : this.inactive;
                });
            }
        });
    }
}

interface Menu {
    name: String;
    componentRoute?: String;
    parentMenuName?: String;
    activeClass?: String;
}

class MenuNameConstants {
    public static DASHBOARD = 'dashBoard';
    public static CLIENTS = 'clients';
    public static REPORTS = 'reports';
    public static PAYMENTS = 'payments';
    public static ADMIN = 'admin';
  public static WORKFLOW = 'workflow';
}



// WEBPACK FOOTER //
// ./src/app/header/navigationbar/navigation-bar.component.ts